var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-banner',{staticClass:"banner-background"},[_c('span',[_vm._v("You are currently on a "),_c('strong',[_vm._v("NON-Production")]),_vm._v(" environment")])])}
var staticRenderFns = []

export { render, staticRenderFns }